import {
  BiometricAuth,
  BiometryError,
  BiometryErrorType,
  BiometryType,
} from '@aparajita/capacitor-biometric-auth';

import { logger } from 'utils/logger';

import {
  BIOMETRIC_PROMPT,
  BIOMETRY_DISPLAY_NAME,
  BIOMETRY_DISPLAY_NAME_FALLBACK,
  UNLOCK_RESULT,
} from './biometricGate.constants';

const getBiometryState = async () => {
  try {
    const info = await BiometricAuth.checkBiometry();

    return {
      isAvailable: info.isAvailable,
      deviceIsSecure: info.deviceIsSecure,
    };
  } catch (error) {
    logger.error('[BiometricGate] checkBiometry failed', error);

    return { isAvailable: false, deviceIsSecure: false };
  }
};

const runAuthenticate = async ({ allowDeviceCredential }) => {
  try {
    await BiometricAuth.authenticate({
      reason: BIOMETRIC_PROMPT.REASON,
      cancelTitle: BIOMETRIC_PROMPT.CANCEL_TITLE,
      allowDeviceCredential,
      iosFallbackTitle: BIOMETRIC_PROMPT.IOS_FALLBACK_TITLE,
      androidTitle: BIOMETRIC_PROMPT.ANDROID_TITLE,
      androidSubtitle: BIOMETRIC_PROMPT.ANDROID_SUBTITLE,
    });

    return UNLOCK_RESULT.GRANTED;
  } catch (error) {
    const isUserCanceled =
      error instanceof BiometryError &&
      (error.code === BiometryErrorType.userCancel ||
        error.code === BiometryErrorType.appCancel ||
        error.code === BiometryErrorType.systemCancel);

    if (!isUserCanceled) {
      logger.error('[BiometricGate] authenticate failed', error);
    }

    return UNLOCK_RESULT.DENIED;
  }
};

export const requireBiometricUnlock = async () => {
  const { isAvailable, deviceIsSecure } = await getBiometryState();

  if (isAvailable) {
    return runAuthenticate({ allowDeviceCredential: true });
  }

  if (deviceIsSecure) {
    return runAuthenticate({ allowDeviceCredential: true });
  }

  logger.warn(
    '[BiometricGate] device has no biometry and no passcode — granting without re-auth (flagged)',
  );

  return UNLOCK_RESULT.NO_SECURITY;
};

export const getBiometryConsentInfo = async () => {
  try {
    const info = await BiometricAuth.checkBiometry();

    return {
      isAvailable: info.isAvailable,
      biometryType: info.biometryType,
      displayName: BIOMETRY_DISPLAY_NAME[info.biometryType] ?? BIOMETRY_DISPLAY_NAME_FALLBACK,
    };
  } catch (error) {
    logger.error('[BiometricGate] getBiometryConsentInfo failed', error);

    return { isAvailable: false, biometryType: BiometryType.none, displayName: null };
  }
};
